/** The first letter of a name, upper case, for the avatar fallback. Null for an empty name. */
export function avatarInitial(name: string | null | undefined): string | null {
  const first = Array.from((name ?? '').trim())[0];
  return first === undefined ? null : first.toLocaleUpperCase();
}

/**
 * True for an address that shows no real picture: none, or the old FreeYourMusic placeholder file
 * (`statics.freeyourmusic.com/images/avatar-placeholder.png`), which answers 404 (onboarding review
 * 2026-10-19, finding 5). An API from before its fix still sends it. The Music24 placeholder of
 * the fixed API (`music24-avatar-placeholder.png`) is a real picture and shows.
 */
export function isPlaceholderAvatarUrl(url: string | null | undefined): boolean {
  return (
    url === null ||
    url === undefined ||
    url.trim() === '' ||
    url.includes('statics.freeyourmusic.com/images/avatar-placeholder.png')
  );
}
